import { render, staticRenderFns } from "./insidecopper.vue?vue&type=template&id=57540172&scoped=true"
import script from "./insidecopper.vue?vue&type=script&lang=js"
export * from "./insidecopper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57540172",
  null
  
)

export default component.exports